import { render, staticRenderFns } from "./DeactivateBrandPopup.vue?vue&type=template&id=6ab812ac&scoped=true&"
import script from "./DeactivateBrandPopup.vue?vue&type=script&lang=ts&"
export * from "./DeactivateBrandPopup.vue?vue&type=script&lang=ts&"
import style0 from "./DeactivateBrandPopup.vue?vue&type=style&index=0&id=6ab812ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ab812ac",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2332429520/src/pickl-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6ab812ac')) {
      api.createRecord('6ab812ac', component.options)
    } else {
      api.reload('6ab812ac', component.options)
    }
    module.hot.accept("./DeactivateBrandPopup.vue?vue&type=template&id=6ab812ac&scoped=true&", function () {
      api.rerender('6ab812ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SAdmin/DeactivateBrandPopup.vue"
export default component.exports